import { Box, IconButton, ModBox, Text, TextInputNew } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { FC, ReactElement, useState } from 'react'
import { TableComponent } from '../../../../comps/TableComponent'
import { ToastPosition, ToastType } from '../../../../comps/Toast'
import { MerchantType } from '../../../../data/models/Merchant'
import { staticStrings } from '../../../../data/static/strings'
import { useStores } from '../../../../data/store'
import { isOsMobile, useWindowDimensions } from '../../../../util/util'
import { MIDListItem } from './MIDListItem'
import { styles1 } from './styles'

interface MIDSelectorProps {
  onSelected: (slectedMid: string) => void
  hide?: boolean
}

const MIDSelector: FC<MIDSelectorProps> = ({ onSelected, hide = false }: MIDSelectorProps) => {
  const {
    updateSelectedMercName,
    updateselectedMercMid,
    updateselectedMercTid,
    updateSelectedStatus,
    selectedMid,
    sortedMerchants,
    saveMerchantDetailsToLocalStorage,
    makePreviousMerchantPermissionEmpty,
    setToastMessage,
  } = useStores(({ user, settings, userManagement, response }) => ({
    updateSelectedMercName: settings.metaData.updateSelectedMercName,
    updateselectedMercMid: user.updateSelectedMercMid,
    updateselectedMercTid: user.updateSelectedMercTid,
    updateSelectedStatus: settings.metaData.updateSelectedMercStatus,
    selectedMid: user.selectedMid,
    sortedMerchants: user?.sortedMerchants,
    saveMerchantDetailsToLocalStorage: user?.saveMerchantDetailsToLocalStorage,
    makePreviousMerchantPermissionEmpty: userManagement.makePreviousMerchantPermissionEmpty,
    setToastMessage: response?.setCustomToast,
  }))
  const viewPortWidth = useWindowDimensions()

  const themedStyle = styles1(viewPortWidth)
  const [selectedCheckbox, setSelectedCheckbox] = useState(selectedMid)
  const [searchString, setSearchString] = useState('')

  if (hide) {
    return null
  }
  const renderListItem = ({ index }: { index: number }): ReactElement | null => {
    const listItemData = sortedMerchants(searchString)[index]
    const handleOnPress = (): void => {
      if (listItemData.isValidMerchant()) {
        makePreviousMerchantPermissionEmpty()
        setSelectedCheckbox(listItemData?.mid)
        updateSelectedMercName(listItemData?.businessName)
        updateselectedMercMid(listItemData?.mid ?? '')
        updateselectedMercTid(listItemData?.tId ?? '')
        updateSelectedStatus(listItemData?.status ?? 'NA')
        const midData = {
          mid: listItemData?.mid ?? '',
          tId: listItemData?.tId ?? '',
          businessName: listItemData?.businessName ?? '',
          status: listItemData?.status ?? '',
        }
        window?.localStorage?.setItem('midData', JSON.stringify(midData))
        onSelected(listItemData.name)
        //Saving data to local storage
        saveMerchantDetailsToLocalStorage({
          mid: listItemData?.mid,
          businessName: listItemData?.businessName,
          tId: listItemData?.businessName,
          status: listItemData?.status ?? 'NA',
          name: listItemData.name,
        })
      }
    }
    const onCopy = () => {
      setToastMessage({
        message: staticStrings.copyText,
        color: 'GREEN',
        position: ToastPosition.BOTTOM,
        toastType: ToastType.POSITIVE,
      })
    }
    return (
      <MIDListItem
        data={listItemData}
        selectedMid={selectedMid}
        selectedCheckbox={selectedCheckbox}
        onPress={handleOnPress}
        breakpoint={viewPortWidth}
        onCopy={onCopy}
      />
    )
  }
  const getSeperator = (): ReactElement => <Box {...themedStyle.seperator} />
  const keyExtractor = (item: MerchantType): string => {
    return item.mid
  }

  const getFlatListHeight = () => {
    const merchants = sortedMerchants(searchString)
    return !isOsMobile() ? (70 * merchants.length < 400 ? merchants.length * 70 : 400) : '100%'
  }

  const textInputStyle = {
    fontFamily: isEmpty(searchString) ? 'jiotype-light' : 'jiotype-medium',
  }

  const rightComp = () => {
    return (
      <IconButton
        id={isEmpty(searchString) ? 'SEARCH' : 'CLOSE'}
        testID={isEmpty(searchString) ? 'SEARCH' : 'CLOSE'}
        onPress={() => setSearchString('')}
        color={isEmpty(searchString) ? 'BLUE' : 'DISABLED_GREY'}
        size={14}
      />
    )
  }
  return (
    <Box {...themedStyle.container} nativeID={'mid-selector'}>
      <Box
        borderTopWidth={1}
        borderBottomWidth={1}
        borderColor={'DISABLED_GREY'}
        pl={16}
        pr={4}
        bg={'WHITE'}
        h={48}
        justify={'center'}>
        <TextInputNew
          rightComponent={rightComp()}
          value={searchString}
          onChangeText={setSearchString}
          onFocusBorderWidth={0}
          borderColor={'TRANSPARENT'}
          placeholder={'Search merchants'}
          placeholderTextColor={'PRIMARY_GREY'}
          color={'BLACK_21'}
          fontSize={isEmpty(searchString) ? 12 : 14}
          {...textInputStyle}
        />
      </Box>
      <TableComponent
        value={''} //Routes value
        canFetchMore={false}
        ListContent={sortedMerchants(searchString)}
        extraData={searchString}
        hide={false}
        isCustom={true}
        RenderCustomElement={renderListItem}
        ItemSeparatorComponent={getSeperator}
        customStyle={themedStyle.flatList(getFlatListHeight())}
        keyExtractor={keyExtractor}
        testID={'invoicesList'}
      />
      <ModBox show={sortedMerchants(searchString)?.length === 0} h={140} justify={'center'} align={'center'}>
        <Text title="No Records found" fontFamily="jiotype-medium" fontSize={12} color={'PRIMARY_GREY'} />
      </ModBox>
    </Box>
  )
}

export default MIDSelector
